import { getServices } from '../utils'

import * as routes from './routes'
import * as ports from './ports'
import * as sailPackages from './sailPackages'

export { routes, ports, sailPackages }

export default getServices(routes, ports, sailPackages)
